<template>
  <transition name="scale-in-out">
    <div
      v-if="show"
      class="app-tooltip--balloon"
      :class="[showClass, elevationClass, directionClass]"
      data-jest="app-tooltip--balloon"
    >
      <div class="app-tooltip--balloon-wrapper">
        <slot />
        <AppArrow v-if="arrow" :direction="arrowDirection" />
      </div>
    </div>
  </transition>
</template>

<script>
// Components
import AppArrow from 'Ui/AppArrow'

export default {
  name: 'AppTooltipBalloon',
  components: {
    AppArrow,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    bottom: {
      type: Boolean,
      default: false,
    },
    arrow: {
      type: Boolean,
      default: false,
    },
    arrowDirection: {
      type: String,
      default: 'up',
    },
    elevation: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showClass() {
      return this.show ? 'show' : ''
    },
    elevationClass() {
      return this.elevation ? '--elevation' : ''
    },
    directionClass() {
      return !this.bottom ? `--top` : `--bottom`
    },
  },
}
</script>

<style scoped>
.app-tooltip--balloon {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 4px;
  user-select: none;
  backface-visibility: hidden;
  will-change: transform;
  transition: var(--transition--default);
  z-index: 999;
}

.app-tooltip--balloon.--elevation {
  box-shadow: 0 0 5px -2px var(--rgba-default);
}

.app-tooltip--balloon-wrapper {
  position: absolute;
  font-size: 12px;
  left: 50%;
  line-height: 20px;
  max-width: 420px;
  letter-spacing: normal;
  width: max-content;
  background-color: var(--c-primary-400);
  padding: 22px 22px 8px 22px;
  border-radius: 4px;
  text-transform: none;
}

.--top .app-tooltip--balloon-wrapper {
  top: -10px;
  transform: translate(-50%, -50%);
}

.--bottom .app-tooltip--balloon-wrapper {
  bottom: 0;
  transform: translate(-50%, 100%);
}
</style>
